import type { LocationQuery } from 'vue-router';
import { isDefined } from './guards/isDefined';
import { ensureArray } from './ensureArray';

export const QUERY_KEY_NAME_PAGE = 'page';
export const QUERY_KEY_NAME_SORT_DIR = 'sort_dir';
export const QUERY_KEY_NAME_SORT = 'sort';

export function createFiltersFromQuery(
  query: LocationQuery
): Record<string, string[]> {
  const options: Record<string, string[]> = {};

  for (const key in query) {
    const value = query[key];
    if (!isDefined(value)) {
      continue;
    }

    options[key] = ensureArray(value)
      .filter(isDefined)
      .map((value) => value.toString());
  }

  return Object.fromEntries(
    Object.entries(options).filter(([_, value]) => value.length > 0)
  );
}
